import { useMemo, useState } from 'react';
import { useOrchestratorList } from '../../hooks/useOrchestratorList';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import { InProgressChartTable } from '../InProgressChartTable/InProgressChartTable';

export const InProgressChart = () => {
  const { orchestrators } = useOrchestratorList();
  const [selectedProcessName, setSelectedProcessName] = useState<string | null>(
    null
  );

  const data = useMemo(() => {
    const counts: Record<string, number> = {};
    orchestrators.data?.forEach(o => {
      o.workflow_steps.forEach(ws => {
        if (ws.status === 'IN_PROGRESS') {
          counts[ws.name] = (counts[ws.name] ?? 0) + 1;
        }
      });
    });
    return Object.entries(counts).map(([name, count]) => ({ name, count }));
  }, [orchestrators.data]);

  const handleBarClick = (data: any) => {
    if (data && data.name) {
      if (selectedProcessName === data.name) {
        setSelectedProcessName(null);
      } else {
        setSelectedProcessName(data.name);
      }
    }
  };

  if (data.length === 0) return <div>No hay datos</div>;

  return (
    <div data-testid="progress-chart">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data as any}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar
            dataKey="count"
            fill="#8884d8"
            onClick={handleBarClick}
            style={{ cursor: 'pointer' }}
          />
        </BarChart>
      </ResponsiveContainer>
      <InProgressChartTable
        selectedProcessName={selectedProcessName}
        onResetSelection={() => setSelectedProcessName(null)}
      />
    </div>
  );
};
